<template>
  <div class="relative">
    <select
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
      :id="'form_' + name"
      :value="value"
      :name="name"
      class="peer inline-flex w-full cursor-pointer appearance-none items-center rounded disabled:pointer-events-none h-11 pe-8 ps-3"
      :class="[{ 'uk-form-danger': error }, 'w-full']"
    >
    <option value="" disabled>{{ $attrs.placeholder ? $attrs.placeholder : 'Bitte wählen' }}</option>
    <option :value="option" v-for="(option, index) in options" :key="index">{{ option }}</option>
    </select>
    <!--<small v-if="error" class="uk-text-danger">{{ error }}</small>-->
    <span class="pointer-events-none absolute inset-y-0 end-0 flex h-full w-9 items-center justify-center text-muted-foreground/80 peer-disabled:opacity-50">
      <svg xmlns="http://www.w3.org/2000/svg" class="size-4" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m6 9l6 6l6-6"/></svg>
    </span>
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  inject: ['$validator'],
  inheritAttrs: false,
  props: {
    value: {
      required: false,
      Type: String,
      default: ''
    },
    name: {
      required: true,
      Type: String
    },
    options: {
      required: true,
      Type: Array
    },
    width: {
      required: false,
      type: String,
      default: '1-1'
    },
    error: {
      type: String,
      default: null
    }
  },
  components: {
    vSelect
  }
}
</script>
